
import styled, { css } from 'styled-components';

const CloseIcon = () => css`
    position: relative;
    height:24px;
    width: 24px;
    top: 1%;
    float:right;
    margin-left:auto;
    order: 2;
    right: 7%;
`;


export default styled.div([CloseIcon]);